// Services pour gérer les appels API
class ApiService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || '';
  }

  private async makeRequest(endpoint: string, options: RequestInit = {}) {
    const token = localStorage.getItem('token');

    const config: RequestInit = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    };

    const response = await fetch(`${this.baseUrl}${endpoint}`, config);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Erreur ${response.status}`);
    }

    return response.json();
  }

  // Méthodes spécifiques
  async getLotsTechniques() {
    const response = await this.makeRequest('/lots-technique/');
    return response?.data || [];
  }

  async getLotsGeographiques() {
    const response = await this.makeRequest('/lots-departements/');
    return response?.data || [];
  }

  async getDepartements() {
    const response = await this.makeRequest('/departements/');
    return response?.data || [];
  }

  async createOperation(operationData: any) {
    const response = await this.makeRequest('/subsequents/operation', {
      method: 'POST',
      body: JSON.stringify(operationData),
    });
    return response?.data;
  }

  // a modifier avec la bonne route
  async createBonCommande(commandeData: any) {
    const response = await this.makeRequest('/bons-commande/operation', {
      method: 'POST',
      body: JSON.stringify(commandeData),
    });
    return response?.data;
  }

  private getEndpointByType(baseEndpoint: string, type: 'MS' | 'BC'): string {
    const endpoints = {
      'MS': baseEndpoint.replace('{type}', 'subsequents'),
      'BC': baseEndpoint.replace('{type}', 'bons-commande')
    };
    return endpoints[type];
  }

  async getCommandeDetails(id: string, type: 'MS' | 'BC') {
    const endpoint = type === 'MS'
      ? `/subsequents/commande/${id}`
      : `/bons-commande/${id}`;

    return this.makeRequest(endpoint);
  }

  async getOperationDetails(id: string, type: 'MS' | 'BC') {
    const endpoint = type === 'MS'
      ? `/subsequents/operation/${id}`
      : `/bons-commande/operation/${id}`;

    return this.makeRequest(endpoint);
  }
}

export const apiService = new ApiService();